module.exports = __webpack_public_path__ + "img/82.water_bar.6b1b2bbc.svg";